<div *ngIf="currentLang === 'ja'">
  <div class="manual-link">
    <a [href]="manualTopLink">使い方トップ</a> » プロジェクト一覧の説明
  </div>

  <div class="manual-main" fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="20px">

  <mat-card appearance="outlined" class="manual-card">
    <mat-card-header>
      <mat-card-title><span>プロジェクト一覧の説明</span></mat-card-title>
    </mat-card-header>

      <mat-card-content>
        <div class="manual-img">
          <img src="assets/img/manual/top.png" width="100%">
        </div>

      <div class="manual-explain-title">
        <img src="assets/img/manual/A.png"> 追加ボタン
      </div>
      <div class="manual-explain">
        クリックすることで追加画面が表示されます。<br>
        ※管理者区分がアドミンユーザーの場合のみ表示されます。
      </div>

      <div class="manual-explain-title">
        <img src="assets/img/manual/B.png"> 削除ボタン
      </div>
      <div class="manual-explain">
        クリックすることで選択した情報を削除します。<br>
        ボタンは、一覧の削除チェックボックスにチェックを入れる事で活性化されます。<br>
        ※管理者区分がアドミンユーザーの場合のみ表示されます。
      </div>

      <div class="manual-explain-title">
        <img src="assets/img/manual/C.png"> Filter
      </div>
      <div class="manual-explain">
        プロジェクト一覧に表示されているデータのフィルタリングを行います。<br>
        ※フィルタリングの対象: ID、名称、備考
      </div>

      <div class="manual-explain-title">
        <img src="assets/img/manual/D.png"> プロジェクト一覧
      </div>
      <div class="manual-explain">
        利用可能なプロジェクト情報の一覧が表示されます。<br>
        編集アイコンをクリックすることで編集画面が表示されます。<br>
        また、「データ管理へ」ボタンをクリックすることで該当プロジェクトのデータ管理画面へ遷移します。<br>
      </div>

      </mat-card-content>
    </mat-card>

  </div>
</div>
<div *ngIf="currentLang === 'en'">
  <div class="manual-link">
    <a [href]="manualTopLink">User Guide Home</a> » Project List Description
  </div>
  
  <div class="manual-main" fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="20px">
  
    <mat-card class="manual-card">
      <mat-card-header>
        <mat-card-title><span>Project List Description</span></mat-card-title>
      </mat-card-header>
  
      <mat-card-content>
        <div class="manual-img">
          <img src="assets/img/manual/en_top.png" width="100%">
        </div>
  
        <div class="manual-explain-title">
          <img src="assets/img/manual/A.png"> Filter
        </div>
        <div class="manual-explain">
          Filters the data displayed in the project list.<br>
          * Filter targets: ID, Name, Remarks
        </div>
  
        <div class="manual-explain-title">
          <img src="assets/img/manual/B.png"> Project List
        </div>
        <div class="manual-explain">
          Displays a list of available project information.<br>
          Click the edit icon to open the edit screen.<br>
          Additionally, click the "Go to Data Management" button to navigate to the data management screen for the selected project.<br>
        </div>
  
      </mat-card-content>
    </mat-card>
  
  </div>  
</div>
